import request from '@/utils/request';

/**
 * @description: 用户中心接口
 */

// 简历列表
export const resumeList = (data) => {
  return request.post('api/Res.Resume/index', data, { authRequired: true });
};

// 删除简历
export const resumeDelete = (data) => {
  return request.post('api/Res.Resume/softDelete', data, { authRequired: true });
};

// 我的投递
export const resumeDelivery = (data) => {
  return request.post('api/Res.ResumeSend/index', data, { authRequired: true });
};

// 更新用户信息
export const update = (data) => {
  return request.post('api/IndexUser/update', data, { authRequired: true });
};

// 上传图片
export const uploadImg = (file) => {
  const form = new FormData();
  form.append('file', file);
  return request.post('/api/base/Upload', form, { authRequired: true });
};
